<template>
  <div class="profile-edit tw-container tw-mx-auto">
    <div class="tw-block lg:tw-flex tw-p-6">
      <div class="tw-p-6">

        <div>
          <div class="tw-flex tw-items-center tw-mb-8 tw-text-xl secondary-c tw-font-bold tw-pl-4">
            <i class="fal fa-cogs tw-mr-4"></i>
            <div>
              {{ $t('profile.settings') }}
            </div>
          </div>
        </div>

        <menu-item v-for="(tab, i) in tabs" :key="i" :item="tab"
                   :text="$t(`profile.${tab.name}`)"
                   :active_item="active_tab" @changeTab="goToTab"></menu-item>

        <div
            v-if="purchase_url"
            :class="['item tw-mb-4 tw-flex tw-items-center tw-pl-4 tw-mb-4 secondary-c tw-cursor-pointer']">
          <div class="tw-block">
            <a :href="purchase_url" target="_blank">{{ $t('profile.purchases') }}</a></div>
          <i :class="['fal fa-chevron-right tw-h-3 tw-ml-auto']"></i>
        </div>

      </div>

      <div class="tw-w-full tw-p-6" v-if="profile_settings">
        <profile-card v-if="active_tab === 'account'" icon="cog" :title="$t('profile.account')">
          <account-tab :profile_settings="profile_settings" @saveAccount="saveAccount" @changeTab="goToTab">
          </account-tab>
        </profile-card>

        <profile-card v-if="active_tab === 'profile'" icon="hashtag" :title="$t('profile.title')">
          <profile-tab :settings="profile_settings" @saveAccount="saveAccount" @changeTab="goToTab">
          </profile-tab>
        </profile-card>

        <profile-card v-if="active_tab === 'privacy'" icon="shield-alt" :title="$t('fields.privacy')">
          <privacy-tab :settings="profile_settings" @saveAccount="saveAccount"></privacy-tab>
        </profile-card>

        <profile-card v-if="active_tab === 'notifications'" icon="bell" :title="$t('profile.notifications')">
          <notifications-tab :settings="profile_settings" @saveAccount="saveAccount"></notifications-tab>
        </profile-card>

        <profile-card v-if="active_tab === 'social'" icon="bell" :title="$t('profile.social')">
          <social-tab :settings="profile_settings" @saveAccount="saveAccount"></social-tab>
        </profile-card>

        <profile-card v-if="active_tab === 'changepassword'" icon="key" :title="$t('profile.change_password')">
          <password-tab :settings="profile_settings" @saveAccount="saveAccount"></password-tab>
        </profile-card>

        <profile-card v-if="active_tab === 'avatar'" icon="user-circle" :title="$t('profile.change_pic')">
          <avatar-tab :profileSettings="profile_settings"></avatar-tab>
        </profile-card>

      </div>
    </div>
  </div>
</template>

<script>
import MenuItem from '../../components/profile/settings/MenuItem.vue';
import AccountTab from '../../components/profile/settings/AccountTab.vue';
import ProfileTab from '../../components/profile/settings/ProfileTab.vue';
import PrivacyTab from '../../components/profile/settings/PrivacyTab.vue';
import NotificationsTab from '../../components/profile/settings/NotificationsTab.vue';
import SocialTab from '../../components/profile/settings/SocialTab.vue';
import PasswordTab from '../../components/profile/settings/PasswordTab.vue';
import AvatarTab from '../../components/profile/settings/AvatarTab.vue';
import Card from '../../components/profile/card/Card.vue';
import Global from '../../mixins/Global';
import Tab from '../../mixins/v2/Tab';
import FormSelect from '../../components/ui/FormSelect.vue';
import Notification from '../../lib/models/Notification';

export default {
  name: 'ProfileEdit',
  mixins: [Global, Tab],

  components: {
    'menu-item': MenuItem,
    'profile-card': Card,
    'form-select': FormSelect,
    'account-tab': AccountTab,
    'profile-tab': ProfileTab,
    'privacy-tab': PrivacyTab,
    'notifications-tab': NotificationsTab,
    'social-tab': SocialTab,
    'password-tab': PasswordTab,
    'avatar-tab': AvatarTab
  },
  data() {
    return {
      user,
      // settings: null,
      tabs: [
        {
          name: 'account',
          childTabs: ['changepassword'],
        },
        {
          name: 'profile',
          childTabs: ['avatar'],
        },
        {
          name: 'social',
        },
        {
          name: 'notifications',
        },
        {
          name: 'privacy',
        }
      ],
      purchase_url: '',
    }
  },
  computed: {
    profile_settings() {
      return HuddleUser.find(this.user.id);
    },
  },
  methods: {
    getProfile() {
      HuddleUser.api().me();
    },
    goToTab(tabName) {
      this.$router.push({ name: 'profile.edit.type', params: { type: tabName } })
      this.changeTab(tabName);
    },
    saveAccount() {
      const birthDate = moment(this.profile_settings.birth_date, "YYYY-MM-DD");

      const data = {
        username: this.profile_settings.username,
        firstname: this.profile_settings.firstname,
        lastname: this.profile_settings.lastname,
        gender: this.profile_settings.gender !== '' ? this.profile_settings.gender : null,
        email: this.profile_settings.email,
        phone: this.profile_settings.profile.phone,
        birth_date: birthDate.isValid() ? birthDate.format("DD-MM-YYYY") : "",
        address: this.profile_settings.profile.address,
        country: this.profile_settings.profile.country,
        zipcode: this.profile_settings.profile.zipcode,
        city: this.profile_settings.profile.city,
        description: this.profile_settings.profile.edit_description,
        facebook: this.profile_settings.profile.facebook,
        instagram: this.profile_settings.profile.instagram,
        twitter: this.profile_settings.profile.twitter,
        pinterest: this.profile_settings.profile.pinterest,
        linkedin: this.profile_settings.profile.linkedin,
        website: this.profile_settings.profile.website,
        hidden: this.profile_settings.profile.hidden,
        follow: this.profile_settings.profile.follow,
        company: this.profile_settings.profile.company,
      }
      HuddleUser.api().update(data).then((response) => {
        if (response.response.data.data.email_change !== null) {
          this.profile_settings.email_change = response.response.data.data.email_change;
        } else {
          this.profile_settings.email_change = null;
        }

        Notification.insert({
          data: [
            {
              title: this.$t('profile.settings_saved'),
            },
          ],
        });
      }).catch((err) => {
        Notification.insert({
          data: [
            {
              title: err,
              status: 'error',
            },
          ],
        });
      });
    },
    async setPurchaseUrl() {
      // Really sorry for this, we can't retrieve users' ip address from the client due to CORS issues.
      // Proxying from the back-end would retrieve the servers' ip address.
      // We can fix this when our server architecture changes in January
      const RANDOM_IP_ADDRESS = "127.0.0.1";

      try {
        const response = await axios.get(`/api/v3/api-clients/plug-and-pay`);

        if (response.data.data.id) {
          const response = await axios.get(`/api/v3/subscriptions/manage?customer_ip=${RANDOM_IP_ADDRESS}`);
          if (response.data.can_manage) {
            this.purchase_url = `${location.hostname}/profile/settings/purchases/manage`;
          }
        }
      } catch (e) {
        const resp = await axios.post(`/api/v4/plug-and-pay/customer-portal/generate-url?ip=${RANDOM_IP_ADDRESS}`);
        if (resp.data.url) {
          this.purchase_url = resp.data.url;
        } else {
          this.purchase_url = '';
        }
      }
    },
  },

  mounted() {
    this.setPurchaseUrl();
    this.getProfile();
  },
}
</script>

<style lang="scss" scoped>
.profile-img {
  &:hover {
    i {
      display: block;
    }
  }
}

.profile-edit::v-deep .general-button {
  max-width: 250px;
}

.profile-edit {
  ::v-deep .vs__dropdown-toggle {
    @apply tw-bg-gray-100;
  }

  ::v-deep .vs__dropdown-menu {
    @apply tw-bg-gray-200;
  }
}
</style>
